import { Modal } from "antd";
import axios from "axios";
import jwtDecode from "jwt-decode";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cleanMenu } from "../redux/menu/menuDucks";
import {
  getUsuarioLogout,
  getUsuarioRefresh,
} from "../redux/usuario/usuarioDucks";
import { SESION } from "../utils";

/**
 * Hook para ejecutar el refresk token
 */
export const RefreshToken = () => {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.usuarioLogin);

  //########### Configuración del token ######################################
  //Se agrega un interceptor para validar todas las peticiones que no retorne un error 401
  axios.interceptors.response.use(
    (res) => res,
    (err) => {      
      if (err.response.status === 401) {
        //Sin acceso, se borra el state del usuario 
        dispatch(getUsuarioLogout());
        dispatch(cleanMenu()); 
      }
      throw err;
    }
  );
  //########### Fin Configuración cuando caduca el token ######################################

  const config = {
    title: "Atención",
    okText: "Aceptar",
    cancelText: "Cerrar sesión",
    keyboard: false,
    content: (
      <>
        <p>{SESION}</p>
      </>
    ),
    onOk() {
      dispatch(getUsuarioRefresh());
    },
    onCancel() {
      dispatch(getUsuarioLogout());
      dispatch(cleanMenu()); //Se limpia las urls del menú
    },
  };

  const configFinish = {
    title: "Atención",
    okText: "Aceptar",
    keyboard: false,
    content: (
      <>
        <p>Su sesión ha expirado</p>
      </>
    ),
    onOk() {
      // dispatch(getUsuarioLogout());
      // dispatch(cleanMenu()); //Se limpia
    },
  };

  useEffect(() => {
    
    // if (willExpireToken(accessToken)) {
    //   if (willExpireTokenFinish(accessToken)) {
    //     Modal.info(configFinish);
    //   } else {
    //     Modal.confirm(config);
    //   }
    // }

    //########### Validar el token  ######################################
    if (willExpireToken(accessToken)) {
      Modal.info(configFinish);
    } else if (willExpireTokenFinish(accessToken)) {      
      Modal.confirm(config);
      return;
    }
    //########### Fin Validar el token ######################################

    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  });  

  return <></>;
};

/**
 * Función que valida si el token ya expiro
 * @param {string} token: Token del usuario
 * @returns {boolean} True si el token ya expiró de lo contrario false
 */
export const willExpireToken = (token) => {
  if(!token) return true;
  const seconds = 60;  
  const metaToken = jwtDecode(token); //decodifica el token
  const { exp } = metaToken; //Se obtiene el tiempo de vida del token
  const now = (Date.now() + seconds) / 1000;
  return now > exp; //verifica que no hay expirado
};
const willExpireTokenFinish = (token) => {
  const seconds = 60;
  const metaToken = jwtDecode(token); //decodifica el token
  const { exp } = metaToken; //Se obtiene el tiempo de vida del token
  // const nowFinish = exp + 300; //5 minutos más
  const nowFinish = exp - 300; //Muestra el mensaje 1 minuto antes de que termine la sesión
  const now = (Date.now() + seconds) / 1000;  
  return now > nowFinish; //verifica que no hay expirado
};
